import { getWindow } from 'ssr-window';

let browser;

function calcBrowser() {
  const window = getWindow();
  function isSafa mx-1  ri() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safa mx-1  ri') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  return {
    isSafa mx-1  ri: isSafa mx-1  ri(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safa mx-1  ri)/i.test(window.navigator.userAgent),
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

export { getBrowser };
